module.exports = {
	"about.close": "Close",
	"about.copyright": "Copyright 2016 Mattermost, Inc. All rights reserved",
	"about.date": "Build Date:",
	"about.enterpriseEditionLearn": "Learn more about Enterprise Edition at ",
	"about.enterpriseEditionSt": "Modern enterprise communication from behind your firewall.",
	"about.enterpriseEditione1": "Enterprise Edition",
	"about.hash": "Build Hash:",
	"about.licensed": "Licensed by:",
	"about.number": "Build Number:",
	"about.teamEditionLearn": "Join the Mattermost community at ",
	"about.teamEditionSt": "All your team communication in one place, instantly searchable and accessible anywhere.",
	"about.teamEditiont0": "Team Edition",
	"about.teamEditiont1": "Enterprise Edition",
	"about.title": "About Mattermost",
	"about.version": "Version:",
	"access_history.title": "Access History",
	"activity_log.activeSessions": "Active Sessions",
	"activity_log.browser": "Browser: {browser}",
	"activity_log.firstTime": "First time active: {date}, {time}",
	"activity_log.lastActivity": "Last activity: {date}, {time}",
	"activity_log.logout": "Logout",
	"activity_log.moreInfo": "More info",
	"activity_log.os": "OS: {os}",
	"activity_log.sessionId": "Session ID: {id}",
	"activity_log.sessionsDescription": "Sessions are created when you log in to a new browser on a device. Sessions let you use Mattermost without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the 'Logout' button below to end a session.",
	"activity_log_modal.android": "Android",
	"activity_log_modal.androidNativeApp": "Android Native App",
	"activity_log_modal.iphoneNativeApp": "iPhone Native App",
	"add_command.autocomplete": "Autocomplete",
	"add_command.autocomplete.help": " Show this command in the autocomplete list.",
	"add_command.autocompleteDescription": "Autocomplete Description",
	"add_command.autocompleteDescription.help": "Optional short description of slash command for the autocomplete list.",
	"add_command.autocompleteDescription.placeholder": "Example: \"Returns search results for patient records\"",
	"add_command.autocompleteHint": "Autocomplete Hint",
	"add_command.autocompleteHint.help": "Optional hint in the autocomplete list about parameters needed for command.",
	"add_command.autocompleteHint.placeholder": "Example: [Patient Name]",
	"add_command.description": "Description",
	"add_command.displayName": "Display Name",
	"add_command.header": "Add",
	"add_command.iconUrl": "Response Icon",
	"add_command.iconUrl.help": "Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.",
	"add_command.iconUrl.placeholder": "https://www.example.com/myicon.png",
	"add_command.method": "Request Method",
	"add_command.method.get": "GET",
	"add_command.method.help": "The type of command request issued to the Request URL.",
	"add_command.method.post": "POST",
	"add_command.trigger": "Command Trigger Word",
	"add_command.trigger.help1": "Examples: /patient, /client, /employee",
	"add_command.trigger.help2": "Reserved: /echo, /join, /logout, /me, /shrug",
	"add_command.trigger.placeholder": "Command trigger e.g. \"hello\" not including the slash",
	"add_command.triggerRequired": "A trigger word is required",
	"add_command.url": "Request URL",
	"add_command.url.help": "The callback URL to receive the HTTP POST or GET event request when the slash command is run.",
	"add_command.url.placeholder": "Must start with http:// or https://",
	"add_command.urlRequired": "A request URL is required",
	"add_command.username": "Response Username",
	"add_command.username.help": "Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and they symbols \"-\", \"_\", and \".\" .",
	"add_command.username.placeholder": "Username",
	"add_incoming_webhook.cancel": "Cancel",
	"add_incoming_webhook.channel": "Channel",
	"add_incoming_webhook.channelRequired": "A valid channel is required",
	"add_incoming_webhook.description": "Description",
	"add_incoming_webhook.header": "Add",
	"add_incoming_webhook.name": "Name",
	"add_incoming_webhook.save": "Save",
	"add_outgoing_webhook.callbackUrls": "Callback URLs (One Per Line)",
	"add_outgoing_webhook.callbackUrlsRequired": "One or more callback URLs are required",
	"add_outgoing_webhook.cancel": "Cancel",
	"add_outgoing_webhook.channel": "Channel",
	"add_outgoing_webhook.description": "Description",
	"add_outgoing_webhook.header": "Add",
	"add_outgoing_webhook.name": "Name",
	"add_outgoing_webhook.save": "Save",
	"add_outgoing_webhook.triggerWOrds": "Trigger Words (One Per Line)",
	"add_outgoing_webhook.triggerWords": "Trigger Words (One Per Line)",
	"add_outgoing_webhook.triggerWordsOrChannelRequired": "A valid channel or a list of trigger words is required",
	"admin.audits.reload": "Reload User Activity Logs",
	"admin.audits.title": "User Activity Logs",
	"admin.compliance.directoryDescription": "Directory to which compliance reports are written. If blank, will be set to ./data/.",
	"admin.compliance.directoryExample": "Ex \"./data/\"",
	"admin.compliance.directoryTitle": "Compliance Directory Location:",
	"admin.compliance.enableDailyDesc": "When true, Mattermost will generate a daily compliance report.",
	"admin.compliance.enableDailyTitle": "Enable Daily Report:",
	"admin.compliance.enableDesc": "When true, Mattermost allows compliance reporting",
	"admin.compliance.enableTitle": "Enable Compliance:",
	"admin.compliance.false": "false",
	"admin.compliance.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href=\"http://mattermost.com\"target=\"_blank\">here</a> for information and pricing on enterprise licenses.</p>",
	"admin.compliance.save": "Save",
	"admin.compliance.saving": "Saving Config...",
	"admin.compliance.title": "Compliance Settings",
	"admin.compliance.true": "true",
	"admin.compliance_reports.desc": "Job Name:",
	"admin.compliance_reports.desc_placeholder": "E.g. \"Audit 445 for HR\"",
	"admin.compliance_reports.emails": "Emails:",
	"admin.compliance_reports.emails_placeholder": "E.g. \"bill@example.com, bob@example.com\"",
	"admin.compliance_reports.from": "From:",
	"admin.compliance_reports.from_placeholder": "E.g. \"2016-03-11\"",
	"admin.compliance_reports.keywords": "Keywords:",
	"admin.compliance_reports.keywords_placeholder": "E.g. \"shorting stock\"",
	"admin.compliance_reports.reload": "Reload Completed Compliance Reports",
	"admin.compliance_reports.run": "Run Compliance Report",
	"admin.compliance_reports.title": "Compliance Reports",
	"admin.compliance_reports.to": "To:",
	"admin.compliance_reports.to_placeholder": "E.g. \"2016-03-15\"",
	"admin.compliance_table.desc": "Description",
	"admin.compliance_table.download": "Download",
	"admin.compliance_table.params": "Params",
	"admin.compliance_table.records": "Records",
	"admin.compliance_table.status": "Status",
	"admin.compliance_table.timestamp": "Timestamp",
	"admin.compliance_table.type": "Type",
	"admin.compliance_table.userId": "Requested By",
	"admin.connectionSecurityNone": "None",
	"admin.connectionSecurityNoneDescription": "Mattermost will connect over an unsecure connection.",
	"admin.connectionSecurityStart": "STARTTLS",
	"admin.connectionSecurityStartDescription": "Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.",
	"admin.connectionSecurityTest": "Test Connection",
	"admin.connectionSecurityTitle": "Connection Security:",
	"admin.connectionSecurityTls": "TLS",
	"admin.connectionSecurityTlsDescription": "Encrypts the communication between Mattermost and your server.",
	"admin.email.agreeHPNS": " I understand and accept the Mattermost Hosted Push Notification Service <a href=\"https://about.mattermost.com/hpns-terms/\" target=\"_blank\">Terms of Service</a> and <a href=\"https://about.mattermost.com/hpns-privacy/\" target=\"_blank\">Privacy Policy</a>.",
	"admin.email.allowEmailSignInDescription": "When true, Mattermost allows users to sign in using their email and password.",
	"admin.email.allowEmailSignInTitle": "Allow Sign In With Email: ",
	"admin.email.allowSignupDescription": "When true, Mattermost allows team creation and account signup using email and password.  This value should be false only when you want to limit signup to a single-sign-on service like OAuth or LDAP.",
	"admin.email.allowSignupTitle": "Allow Sign Up With Email: ",
	"admin.email.allowUsernameSignInDescription": "When true, Mattermost allows users to sign in using their username and password.  This setting is typically only used when email verification is disabled.",
	"admin.email.allowUsernameSignInTitle": "Allow Sign In With Username: ",
	"admin.email.easHelp": "Learn more about compiling and deploying your own mobile apps from an <a href=\"http://docs.mattermost.com/deployment/push.html#enterprise-app-store-eas\" target=\"_blank\">Enterprise App Store</a>.",
	"admin.email.emailFail": "Connection unsuccessful: {error}",
	"admin.email.emailSettings": "Email Settings",
	"admin.email.emailSuccess": "No errors were reported while sending an email.  Please check your inbox to make sure.",
	"admin.email.false": "false",
	"admin.email.fullPushNotification": "Send full message snippet",
	"admin.email.genericPushNotification": "Send generic description with user and channel names",
	"admin.email.inviteSaltDescription": "32-character salt added to signing of email invites. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
	"admin.email.inviteSaltExample": "Ex \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
	"admin.email.inviteSaltTitle": "Invite Salt:",
	"admin.email.mhpns": "Use encrypted, production-quality HPNS connection to iOS and Android apps",
	"admin.email.mhpnsHelp": "Download <a href=\"https://itunes.apple.com/us/app/mattermost/id984966508?mt=8\" target=\"_blank\">Mattermost iOS app</a> from iTunes. Download <a href=\"https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en\" target=\"_blank\">Mattermost Android app</a> from Google Play. Learn more about <a href=\"http://docs.mattermost.com/deployment/push.html#hosted-push-notifications-service-hpns\" target=\"_blank\">HPNS</a>.",
	"admin.email.mtpns": "Use iOS and Android apps on iTunes and Google Play with TPNS",
	"admin.email.mtpnsHelp": "Download <a href=\"https://itunes.apple.com/us/app/mattermost/id984966508?mt=8\" target=\"_blank\">Mattermost iOS app</a> from iTunes. Download <a href=\"https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en\" target=\"_blank\">Mattermost Android app</a> from Google Play. Learn more about <a href=\"http://docs.mattermost.com/deployment/push.html#test-push-notifications-service-tpns\" target=\"_blank\">TPNS</a>.",
	"admin.email.notificationDisplayDescription": "Display name on email account used when sending notification emails from Mattermost.",
	"admin.email.notificationDisplayExample": "Ex: \"Mattermost Notification\", \"System\", \"No-Reply\"",
	"admin.email.notificationDisplayTitle": "Notification Display Name:",
	"admin.email.notificationEmailDescription": "Email address displayed on email account used when sending notification emails from Mattermost.",
	"admin.email.notificationEmailExample": "Ex: \"mattermost@yourcompany.com\", \"admin@yourcompany.com\"",
	"admin.email.notificationEmailTitle": "Notification Email Address:",
	"admin.email.notificationsDescription": "Typically set to true in production. When true, Mattermost attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).",
	"admin.email.notificationsTitle": "Send Email Notifications: ",
	"admin.email.passwordSaltDescription": "32-character salt added to signing of password reset emails. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
	"admin.email.passwordSaltExample": "Ex \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
	"admin.email.passwordSaltTitle": "Password Reset Salt:",
	"admin.email.pushContentDesc": "Selecting \"Send generic description with user and channel names\" provides push notifications with generic messages, including names of users and channels but no specific details from the message text.<br /><br />Selecting \"Send full message snippet\" sends excerpts from messages triggering notifications with specifics and may include confidential information sent in messages. If your Push Notification Service is outside your firewall, it is HIGHLY RECOMMENDED this option only be used with an \"https\" protocol to encrypt the connection.",
	"admin.email.pushContentTitle": "Push Notification Contents:",
	"admin.email.pushDesc": "Typically set to true in production. When true, Mattermost attempts to send iOS and Android push notifications through the push notification server.",
	"admin.email.pushOff": "Do not send push notifications",
	"admin.email.pushOffHelp": "Please see <a href=\"http://docs.mattermost.com/deployment/push.html#push-notifications-and-mobile-devices\" target=\"_blank\">documentation on push notifications</a> to learn more about setup options.",
	"admin.email.pushServerDesc": "Location of Mattermost push notification service you can set up behind your firewall using https://github.com/mattermost/push-proxy. For testing you can use http://push-test.mattermost.com, which connects to the sample Mattermost iOS app in the public Apple AppStore. Please do not use test service for production deployments.",
	"admin.email.pushServerEx": "E.g.: \"http://push-test.mattermost.com\"",
	"admin.email.pushServerTitle": "Push Notification Server:",
	"admin.email.pushTitle": "Send Push Notifications: ",
	"admin.email.regenerate": "Re-Generate",
	"admin.email.requireVerificationDescription": "Typically set to true in production. When true, Mattermost requires email verification after account creation prior to allowing login. Developers may set this field to false so skip sending verification emails for faster development.",
	"admin.email.requireVerificationTitle": "Require Email Verification: ",
	"admin.email.save": "Save",
	"admin.email.saving": "Saving Config...",
	"admin.email.selfPush": "Manually enter Push Notification Service location",
	"admin.email.smtpPasswordDescription": " Obtain this credential from administrator setting up your email server.",
	"admin.email.smtpPasswordExample": "Ex: \"yourpassword\", \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.email.smtpPasswordTitle": "SMTP Password:",
	"admin.email.smtpPortDescription": "Port of SMTP email server.",
	"admin.email.smtpPortExample": "Ex: \"25\", \"465\"",
	"admin.email.smtpPortTitle": "SMTP Port:",
	"admin.email.smtpServerDescription": "Location of SMTP email server.",
	"admin.email.smtpServerExample": "Ex: \"smtp.yourcompany.com\", \"email-smtp.us-east-1.amazonaws.com\"",
	"admin.email.smtpServerTitle": "SMTP Server:",
	"admin.email.smtpUsernameDescription": " Obtain this credential from administrator setting up your email server.",
	"admin.email.smtpUsernameExample": "Ex: \"admin@yourcompany.com\", \"AKIADTOVBGERKLCBV\"",
	"admin.email.smtpUsernameTitle": "SMTP Username:",
	"admin.email.testing": "Testing...",
	"admin.email.true": "true",
	"admin.gitab.clientSecretDescription": "Obtain this value via the instructions above for logging into GitLab.",
	"admin.gitlab.EnableHtmlDesc": "<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs \"<your-mattermost-url>/login/gitlab/complete\" (example: http://localhost:8065/login/gitlab/complete) and \"<your-mattermost-url>/signup/gitlab/complete\". </li><li>Then use \"Secret\" and \"Id\" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>",
	"admin.gitlab.authDescription": "Enter https://<your-gitlab-url>/oauth/authorize (example https://example.com:3000/oauth/authorize).   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.authExample": "Ex \"\"",
	"admin.gitlab.authTitle": "Auth Endpoint:",
	"admin.gitlab.clientIdDescription": "Obtain this value via the instructions above for logging into GitLab",
	"admin.gitlab.clientIdExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.gitlab.clientIdTitle": "Id:",
	"admin.gitlab.clientSecretExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.gitlab.clientSecretTitle": "Secret:",
	"admin.gitlab.enableDescription": "When true, Mattermost allows team creation and account signup using GitLab OAuth.",
	"admin.gitlab.enableTitle": "Enable Sign Up With GitLab: ",
	"admin.gitlab.false": "false",
	"admin.gitlab.save": "Save",
	"admin.gitlab.saving": "Saving Config...",
	"admin.gitlab.settingsTitle": "GitLab Settings",
	"admin.gitlab.tokenDescription": "Enter https://<your-gitlab-url>/oauth/token.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.tokenExample": "Ex \"\"",
	"admin.gitlab.tokenTitle": "Token Endpoint:",
	"admin.gitlab.true": "true",
	"admin.gitlab.userDescription": "Enter https://<your-gitlab-url>/api/v3/user.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
	"admin.gitlab.userExample": "Ex \"\"",
	"admin.gitlab.userTitle": "User API Endpoint:",
	"admin.image.amazonS3BucketDescription": "Name you selected for your S3 bucket in AWS.",
	"admin.image.amazonS3BucketExample": "Ex \"mattermost-media\"",
	"admin.image.amazonS3BucketTitle": "Amazon S3 Bucket:",
	"admin.image.amazonS3IdDescription": "Obtain this credential from your Amazon EC2 administrator.",
	"admin.image.amazonS3IdExample": "Ex \"AKIADTOVBGERKLCBV\"",
	"admin.image.amazonS3IdTitle": "Amazon S3 Access Key Id:",
	"admin.image.amazonS3RegionDescription": "AWS region you selected for creating your S3 bucket.",
	"admin.image.amazonS3RegionExample": "Ex \"us-east-1\"",
	"admin.image.amazonS3RegionTitle": "Amazon S3 Region:",
	"admin.image.amazonS3SecretDescription": "Obtain this credential from your Amazon EC2 administrator.",
	"admin.image.amazonS3SecretExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
	"admin.image.amazonS3SecretTitle": "Amazon S3 Secret Access Key:",
	"admin.image.false": "false",
	"admin.image.fileSettings": "File Settings",
	"admin.image.localDescription": "Directory to which image files are written. If blank, will be set to ./data/.",
	"admin.image.localExample": "Ex \"./data/\"",
	"admin.image.localTitle": "Local Directory Location:",
	"admin.image.previewHeightDescription": "Maximum height of preview image (\"0\": Sets to auto-size). Updating this value changes how preview images render in future, but does not change images created in the past.",
	"admin.image.previewHeightExample": "Ex \"0\"",
	"admin.image.previewHeightTitle": "Preview Height:",
	"admin.image.previewWidthDescription": "Maximum width of preview image. Updating this value changes how preview images render in future, but does not change images created in the past.",
	"admin.image.previewWidthExample": "Ex \"1024\"",
	"admin.image.previewWidthTitle": "Preview Width:",
	"admin.image.profileHeightDescription": "Height of profile picture.",
	"admin.image.profileHeightExample": "Ex \"0\"",
	"admin.image.profileHeightTitle": "Profile Height:",
	"admin.image.profileWidthDescription": "Width of profile picture.",
	"admin.image.profileWidthExample": "Ex \"1024\"",
	"admin.image.profileWidthTitle": "Profile Width:",
	"admin.image.publicLinkDescription": "32-character salt added to signing of public image links. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
	"admin.image.publicLinkExample": "Ex \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
	"admin.image.publicLinkTitle": "Public Link Salt:",
	"admin.image.regenerate": "Re-Generate",
	"admin.image.save": "Save",
	"admin.image.saving": "Saving Config...",
	"admin.image.shareDescription": "Allow users to share public links to files and images.",
	"admin.image.shareTitle": "Share Public File Link: ",
	"admin.image.storeAmazonS3": "Amazon S3",
	"admin.image.storeLocal": "Local File System",
	"admin.image.storeTitle": "Store Files In:",
	"admin.image.thumbHeightDescription": "Height of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.",
	"admin.image.thumbHeightExample": "Ex \"100\"",
	"admin.image.thumbHeightTitle": "Thumbnail Height:",
	"admin.image.thumbWidthDescription": "Width of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.",
	"admin.image.thumbWidthExample": "Ex \"120\"",
	"admin.image.thumbWidthTitle": "Thumbnail Width:",
	"admin.image.true": "true",
	"admin.ldap.bannerDesc": "If a user attribute changes on the LDAP server it will be updated the next time the user enters their credentials to log in to Mattermost. This includes if a user is made inactive or removed from an LDAP server. Synchronization with LDAP servers is planned in a future release.",
	"admin.ldap.bannerHeading": "Note:",
	"admin.ldap.baseDesc": "The Base DN is the Distinguished Name of the location where Mattermost should start its search for users in the LDAP tree.",
	"admin.ldap.baseEx": "Ex \"ou=Unit Name,dc=corp,dc=example,dc=com\"",
	"admin.ldap.baseTitle": "BaseDN:",
	"admin.ldap.bindPwdDesc": "Password of the user given in \"Bind Username\".",
	"admin.ldap.bindPwdTitle": "Bind Password:",
	"admin.ldap.bindUserDesc": "The username used to perform the LDAP search. This should typically be an account created specifically for use with Mattermost. It should have access limited to read the portion of the LDAP tree specified in the BaseDN field.",
	"admin.ldap.bindUserTitle": "Bind Username:",
	"admin.ldap.emailAttrDesc": "The attribute in the LDAP server that will be used to populate the email addresses of users in Mattermost.",
	"admin.ldap.emailAttrEx": "Ex \"mail\" or \"userPrincipalName\"",
	"admin.ldap.emailAttrTitle": "Email Attribute:",
	"admin.ldap.enableDesc": "When true, Mattermost allows login using LDAP",
	"admin.ldap.enableTitle": "Enable Login With LDAP:",
	"admin.ldap.false": "false",
	"admin.ldap.firstnameAttrDesc": "The attribute in the LDAP server that will be used to populate the first name of users in Mattermost.",
	"admin.ldap.firstnameAttrEx": "Ex \"givenName\"",
	"admin.ldap.firstnameAttrTitle": "First Name Attrubute",
	"admin.ldap.idAttrDesc": "The attribute in the LDAP server that will be used as a unique identifier in Mattermost. It should be an LDAP attribute with a value that does not change, such as username or uid. If a user’s Id Attribute changes, it will create a new Mattermost account unassociated with their old one. This is the value used to log in to Mattermost in the \"LDAP Username\" field on the sign in page. Normally this attribute is the same as the “Username Attribute” field above. If your team typically uses domain\\\\username to sign in to other services with LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.",
	"admin.ldap.idAttrEx": "Ex \"sAMAccountName\"",
	"admin.ldap.idAttrTitle": "Id Attribute: ",
	"admin.ldap.lastnameAttrDesc": "The attribute in the LDAP server that will be used to populate the last name of users in Mattermost.",
	"admin.ldap.lastnameAttrEx": "Ex \"sn\"",
	"admin.ldap.lastnameAttrTitle": "Last Name Attribute:",
	"admin.ldap.loginNameDesc": "The placeholder text that appears in the login field on the login page. Defaults to \"LDAP Username\".",
	"admin.ldap.loginNameEx": "Ex \"LDAP Username\"",
	"admin.ldap.loginNameTitle": "Login Field Name:",
	"admin.ldap.nicknameAttrDesc": "(Optional) The attribute in the LDAP server that will be used to populate the nickname of users in Mattermost.",
	"admin.ldap.nicknameAttrEx": "Ex \"nickname\"",
	"admin.ldap.nicknameAttrTitle": "Nickname Attribute:",
	"admin.ldap.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>LDAP is an enterprise feature. Your current license does not support LDAP. Click <a href=\"http://mattermost.com\"target=\"_blank\">here</a> for information and pricing on enterprise licenses.</p>",
	"admin.ldap.portDesc": "The port Mattermost will use to connect to the LDAP server. Default is 389.",
	"admin.ldap.portEx": "Ex \"389\"",
	"admin.ldap.portTitle": "LDAP Port:",
	"admin.ldap.queryDesc": "The timeout value for queries to the LDAP server. Increase if you are getting timeout errors caused by a slow LDAP server.",
	"admin.ldap.queryEx": "Ex \"60\"",
	"admin.ldap.queryTitle": "Query Timeout (seconds):",
	"admin.ldap.save": "Save",
	"admin.ldap.saving": "Saving Config...",
	"admin.ldap.serverDesc": "The domain or IP address of LDAP server.",
	"admin.ldap.serverEx": "Ex \"10.0.0.23\"",
	"admin.ldap.serverTitle": "LDAP Server:",
	"admin.ldap.skipCertificateVerification": "Skip Certificate Verification",
	"admin.ldap.skipCertificateVerificationDesc": "Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.",
	"admin.ldap.title": "LDAP Settings",
	"admin.ldap.true": "true",
	"admin.ldap.uernameAttrDesc": "The attribute in the LDAP server that will be used to populate the username field in Mattermost. This may be the same as the ID Attribute.",
	"admin.ldap.userFilterDisc": "Optionally enter an LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Mattermost. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).",
	"admin.ldap.userFilterEx": "Ex. \"(objectClass=user)\"",
	"admin.ldap.userFilterTitle": "User Filter:",
	"admin.ldap.usernameAttrEx": "Ex \"sAMAccountName\"",
	"admin.ldap.usernameAttrTitle": "Username Attribute:",
	"admin.license.choose": "Choose File",
	"admin.license.chooseFile": "Choose File",
	"admin.license.edition": "Edition: ",
	"admin.license.key": "License Key: ",
	"admin.license.keyRemove": "Remove Enterprise License and Downgrade Server",
	"admin.license.noFile": "No file uploaded",
	"admin.license.removing": "Removing License...",
	"admin.license.title": "Edition and License",
	"admin.license.type": "License: ",
	"admin.license.upload": "Upload",
	"admin.license.uploadDesc": "Upload a license key for Mattermost Enterprise Edition to upgrade this server. <a href=\"http://mattermost.com\" target=\"_blank\">Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.",
	"admin.license.uploading": "Uploading License...",
	"admin.log.consoleDescription": "Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).",
	"admin.log.consoleTitle": "Log To The Console: ",
	"admin.log.false": "false",
	"admin.log.fileDescription": "Typically set to true in production.  When true, log files are written to the log file specified in file location field below.",
	"admin.log.fileLevelDescription": "This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
	"admin.log.fileLevelTitle": "File Log Level:",
	"admin.log.fileTitle": "Log To File: ",
	"admin.log.formatDateLong": "Date (2006/01/02)",
	"admin.log.formatDateShort": "Date (01/02/06)",
	"admin.log.formatDescription": "Format of log message output. If blank will be set to \"[%D %T] [%L] %M\", where:",
	"admin.log.formatLevel": "Level (DEBG, INFO, EROR)",
	"admin.log.formatMessage": "Message",
	"admin.log.formatPlaceholder": "Enter your file format",
	"admin.log.formatSource": "Source",
	"admin.log.formatTime": "Time (15:04:05 MST)",
	"admin.log.formatTitle": "File Format:",
	"admin.log.levelDescription": "This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
	"admin.log.levelTitle": "Console Log Level:",
	"admin.log.locationDescription": "File to which log files are written. If blank, will be set to ./logs/mattermost, which writes logs to mattermost.log. Log rotation is enabled and every 10,000 lines of log information is written to new files stored in the same directory, for example mattermost.2015-09-23.001, mattermost.2015-09-23.002, and so forth.",
	"admin.log.locationPlaceholder": "Enter your file location",
	"admin.log.locationTitle": "File Location:",
	"admin.log.logSettings": "Log Settings",
	"admin.log.save": "Save",
	"admin.log.saving": "Saving Config...",
	"admin.log.true": "true",
	"admin.logs.reload": "Reload",
	"admin.logs.title": "Server Logs",
	"admin.nav.help": "Help",
	"admin.nav.logout": "Logout",
	"admin.nav.report": "Report a Problem",
	"admin.nav.switch": "Switch to {display_name}",
	"admin.privacy.false": "false",
	"admin.privacy.save": "Save",
	"admin.privacy.saving": "Saving Config...",
	"admin.privacy.showEmailDescription": "When false, hides email address of users from other users in the user interface, including team owners and team administrators. Used when system is set up for managing teams where some users choose to keep their contact information private.",
	"admin.privacy.showEmailTitle": "Show Email Address: ",
	"admin.privacy.showFullNameDescription": "When false, hides full name of users from other users, including team owners and team administrators. Username is shown in place of full name.",
	"admin.privacy.showFullNameTitle": "Show Full Name: ",
	"admin.privacy.title": "Privacy Settings",
	"admin.privacy.true": "true",
	"admin.rate.enableLimiterDescription": "When true, APIs are throttled at rates specified below.",
	"admin.rate.enableLimiterTitle": "Enable Rate Limiter: ",
	"admin.rate.false": "false",
	"admin.rate.httpHeaderDescription": "When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to \"X-Real-IP\", when configuring AmazonELB set to \"X-Forwarded-For\").",
	"admin.rate.httpHeaderExample": "Ex \"X-Real-IP\", \"X-Forwarded-For\"",
	"admin.rate.httpHeaderTitle": "Vary By HTTP Header:",
	"admin.rate.memoryDescription": "Maximum number of users sessions connected to the system as determined by \"Vary By Remote Address\" and \"Vary By Header\" settings below.",
	"admin.rate.memoryExample": "Ex \"10000\"",
	"admin.rate.memoryTitle": "Memory Store Size:",
	"admin.rate.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
	"admin.rate.noteTitle": "Note:",
	"admin.rate.queriesDescription": "Throttles API at this number of requests per second.",
	"admin.rate.queriesExample": "Ex \"10\"",
	"admin.rate.queriesTitle": "Number Of Queries Per Second:",
	"admin.rate.remoteDescription": "When true, rate limit API access by IP address.",
	"admin.rate.remoteTitle": "Vary By Remote Address: ",
	"admin.rate.save": "Save",
	"admin.rate.saving": "Saving Config...",
	"admin.rate.title": "Rate Limit Settings",
	"admin.rate.true": "true",
	"admin.reset_password.close": "Close",
	"admin.reset_password.newPassword": "New Password",
	"admin.reset_password.select": "Select",
	"admin.reset_password.submit": "Please enter at least {chars} characters.",
	"admin.reset_password.titleReset": "Reset Password",
	"admin.reset_password.titleSwitch": "Switch Account to Email/Password",
	"admin.select_team.close": "Close",
	"admin.select_team.select": "Select",
	"admin.select_team.selectTeam": "Select Team",
	"admin.service.attemptDescription": "Login attempts allowed before user is locked out and required to reset password via email.",
	"admin.service.attemptExample": "Ex \"10\"",
	"admin.service.attemptTitle": "Maximum Login Attempts:",
	"admin.service.cmdsDesc": "When true, user created slash commands will be allowed.",
	"admin.service.cmdsTitle": "Enable Slash Commands: ",
	"admin.service.corsDescription": "Enable HTTP Cross origin request from a specific domain. Use \"*\" if you want to allow CORS from any domain or leave it blank to disable it.",
	"admin.service.corsEx": "http://example.com",
	"admin.service.corsTitle": "Allow Cross-origin Requests from:",
	"admin.service.developerDesc": "(Developer Option) When true, extra information around errors will be displayed in the UI.",
	"admin.service.developerTitle": "Enable Developer Mode: ",
	"admin.service.false": "false",
	"admin.service.googleDescription": "Set this key to enable embedding of YouTube video previews based on hyperlinks appearing in messages or comments. Instructions to obtain a key available at <a href=\"https://www.youtube.com/watch?v=Im69kzhpR3I\" target=\"_blank\">https://www.youtube.com/watch?v=Im69kzhpR3I</a>. Leaving the field blank disables the automatic generation of YouTube video previews from links.",
	"admin.service.googleExample": "Ex \"7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV\"",
	"admin.service.googleTitle": "Google Developer Key:",
	"admin.service.iconDescription": "When true, webhooks and slash commands will be allowed to change the icon they post with. Note, combined with allowing username overriding, this could open users up to phishing attacks.",
	"admin.service.iconTitle": "Enable Overriding Icon from Webhooks and Slash Commands: ",
	"admin.service.insecureTlsDesc": "When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.",
	"admin.service.insecureTlsTitle": "Enable Insecure Outgoing Connections: ",
	"admin.service.integrationAdmin": "Enable Integrations for Admin Only: ",
	"admin.service.integrationAdminDesc": "When true, user created integrations can only be created by admins.",
	"admin.service.listenAddress": "Listen Address:",
	"admin.service.listenDescription": "The address to which to bind and listen. Entering \":8065\" will bind to all interfaces or you can choose one like \"127.0.0.1:8065\".  Changing this will require a server restart before taking effect.",
	"admin.service.listenExample": "Ex \":8065\"",
	"admin.service.mfaDesc": "When true, users will be given the option to add multi-factor authentication to their account. They will need a smartphone and an authenticator app such as Google Authenticator.",
	"admin.service.mfaTitle": "Enable Multi-factor Authentication:",
	"admin.service.mobileSessionDays": "Session Length for Mobile Device in Days:",
	"admin.service.mobileSessionDaysDesc": "The native mobile session will expire after the number of days specified and will require a user to login again.",
	"admin.service.outWebhooksDesc": "When true, outgoing webhooks will be allowed.",
	"admin.service.outWebhooksTitle": "Enable Outgoing Webhooks: ",
	"admin.service.overrideDescription": "When true, webhooks and slash commands will be allowed to change the username they are posting as. Note, combined with allowing icon overriding, this could open users up to phishing attacks.",
	"admin.service.overrideTitle": "Enable Overriding Usernames from Webhooks and Slash Commands: ",
	"admin.service.save": "Save",
	"admin.service.saving": "Saving Config...",
	"admin.service.securityDesc": "When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.",
	"admin.service.securityTitle": "Enable Security Alerts: ",
	"admin.service.segmentDescription": "For users running a SaaS services, sign up for a key at Segment.com to track metrics.",
	"admin.service.segmentExample": "Ex \"g3fgGOXJAQ43QV7rAh6iwQCkV4cA1Gs\"",
	"admin.service.segmentTitle": "Segment Developer Key:",
	"admin.service.sessionCache": "Session Cache in Minutes:",
	"admin.service.sessionCacheDesc": "The number of minutes to cache a session in memory.",
	"admin.service.sessionDaysEx": "Ex \"30\"",
	"admin.service.ssoSessionDays": "Session Length for SSO in Days:",
	"admin.service.ssoSessionDaysDesc": "The SSO session will expire after the number of days specified and will require a user to login again.",
	"admin.service.testingDescription": "(Developer Option) When true, /loadtest slash command is enabled to load test accounts and test data. Changing this will require a server restart before taking effect.",
	"admin.service.testingTitle": "Enable Testing: ",
	"admin.service.title": "Service Settings",
	"admin.service.true": "true",
	"admin.service.webSessionDays": "Session Length for Web in Days:",
	"admin.service.webSessionDaysDesc": "The web session will expire after the number of days specified and will require a user to login again.",
	"admin.service.webhooksDescription": "When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag.",
	"admin.service.webhooksTitle": "Enable Incoming Webhooks: ",
	"admin.sidebar.addTeamSidebar": "Add team from sidebar menu",
	"admin.sidebar.audits": "Compliance and Auditing",
	"admin.sidebar.compliance": "Compliance Settings",
	"admin.sidebar.email": "Email Settings",
	"admin.sidebar.file": "File Settings",
	"admin.sidebar.gitlab": "GitLab Settings",
	"admin.sidebar.ldap": "LDAP Settings",
	"admin.sidebar.license": "Edition and License",
	"admin.sidebar.loading": "Loading",
	"admin.sidebar.log": "Log Settings",
	"admin.sidebar.logs": "Logs",
	"admin.sidebar.other": "OTHER",
	"admin.sidebar.privacy": "Privacy Settings",
	"admin.sidebar.rate_limit": "Rate Limit Settings",
	"admin.sidebar.reports": "SITE REPORTS",
	"admin.sidebar.rmTeamSidebar": "Remove team from sidebar menu",
	"admin.sidebar.service": "Service Settings",
	"admin.sidebar.settings": "SETTINGS",
	"admin.sidebar.sql": "SQL Settings",
	"admin.sidebar.statistics": "- Statistics",
	"admin.sidebar.support": "Legal and Support Settings",
	"admin.sidebar.team": "Team Settings",
	"admin.sidebar.teams": "TEAMS ({count})",
	"admin.sidebar.users": "- Users",
	"admin.sidebar.view_statistics": "View Statistics",
	"admin.sidebarHeader.systemConsole": "System Console",
	"admin.sql.dataSource": "Data Source:",
	"admin.sql.driverName": "Driver Name:",
	"admin.sql.false": "false",
	"admin.sql.keyDescription": "32-character salt available to encrypt and decrypt sensitive fields in database.",
	"admin.sql.keyExample": "Ex \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
	"admin.sql.keyTitle": "At Rest Encrypt Key:",
	"admin.sql.maxConnectionsDescription": "Maximum number of idle connections held open to the database.",
	"admin.sql.maxConnectionsExample": "Ex \"10\"",
	"admin.sql.maxConnectionsTitle": "Maximum Idle Connections:",
	"admin.sql.maxOpenDescription": "Maximum number of open connections held open to the database.",
	"admin.sql.maxOpenExample": "Ex \"10\"",
	"admin.sql.maxOpenTitle": "Maximum Open Connections:",
	"admin.sql.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
	"admin.sql.noteTitle": "Note:",
	"admin.sql.regenerate": "Re-Generate",
	"admin.sql.replicas": "Data Source Replicas:",
	"admin.sql.save": "Save",
	"admin.sql.saving": "Saving Config...",
	"admin.sql.title": "SQL Settings",
	"admin.sql.traceDescription": "(Development Mode) When true, executing SQL statements are written to the log.",
	"admin.sql.traceTitle": "Trace: ",
	"admin.sql.true": "true",
	"admin.sql.warning": "Warning: re-generating this salt may cause some columns in the database to return empty results.",
	"admin.support.aboutDesc": "Link to About page for more information on your Mattermost deployment, for example its purpose and audience within your organization. Defaults to Mattermost information page.",
	"admin.support.aboutTitle": "About link:",
	"admin.support.emailHelp": "Email shown during tutorial for end users to ask support questions.",
	"admin.support.emailTitle": "Support email:",
	"admin.support.helpDesc": "Link to help documentation from team site main menu. Typically not changed unless your organization chooses to create custom documentation.",
	"admin.support.helpTitle": "Help link:",
	"admin.support.noteDescription": "If linking to an external site, URLs should begin with http:// or https://.",
	"admin.support.noteTitle": "Note:",
	"admin.support.privacyDesc": "Link to Privacy Policy available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.",
	"admin.support.privacyTitle": "Privacy Policy link:",
	"admin.support.problemDesc": "Link to help documentation from team site main menu. By default this points to the peer-to-peer troubleshooting forum where users can search for, find and request help with technical issues.",
	"admin.support.problemTitle": "Report a Problem link:",
	"admin.support.save": "Save",
	"admin.support.saving": "Saving Config...",
	"admin.support.termsDesc": "Link to Terms of Service available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.",
	"admin.support.termsTitle": "Terms of Service link:",
	"admin.support.title": "Legal and Support Settings",
	"admin.system_analytics.activeUsers": "Active Users With Posts",
	"admin.system_analytics.title": "the System",
	"admin.system_analytics.totalPosts": "Total Posts",
	"admin.team.brandDesc": "Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.",
	"admin.team.brandImageTitle": "Custom Brand Image:",
	"admin.team.brandTextDescription": "The custom branding Markdown-formatted text you would like to appear below your custom brand image on your login screen.",
	"admin.team.brandTextTitle": "Custom Brand Text:",
	"admin.team.brandTitle": "Enable Custom Branding: ",
	"admin.team.chooseImage": "Choose New Image",
	"admin.team.dirDesc": "When true, teams that are configured to show in team directory will show on main page inplace of creating a new team.",
	"admin.team.dirTitle": "Enable Team Directory: ",
	"admin.team.false": "false",
	"admin.team.maxUsersDescription": "Maximum total number of users per team, including both active and inactive users.",
	"admin.team.maxUsersExample": "Ex \"25\"",
	"admin.team.maxUsersTitle": "Max Users Per Team:",
	"admin.team.noBrandImage": "No brand image uploaded",
	"admin.team.openServerDescription": "When true, anyone can signup for a user account on this server without the need to be invited.",
	"admin.team.openServerTitle": "Enable Open Server: ",
	"admin.team.restrictDescription": "Teams and user accounts can only be created from a specific domain (e.g. \"mattermost.org\") or list of comma-separated domains (e.g. \"corp.mattermost.com, mattermost.org\").",
	"admin.team.restrictDirectMessage": "Enable users to open Direct Message channels with:",
	"admin.team.restrictDirectMessageDesc": "'Any user on the Mattermost server' enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. 'Any member of the team' limits the ability to open Direct Message channels to only users who are in the same team.",
	"admin.team.restrictExample": "Ex \"corp.mattermost.com, mattermost.org\"",
	"admin.team.restrictNameDesc": "When true, You cannot create a team name with reserved words like www, admin, support, test, channel, etc",
	"admin.team.restrictNameTitle": "Restrict Team Names: ",
	"admin.team.restrictTitle": "Restrict Creation To Domains:",
	"admin.team.restrict_direct_message_any": "Any user on the Mattermost server",
	"admin.team.restrict_direct_message_team": "Any member of the team",
	"admin.team.save": "Save",
	"admin.team.saving": "Saving Config...",
	"admin.team.siteNameDescription": "Name of service shown in login screens and UI.",
	"admin.team.siteNameExample": "Ex \"Mattermost\"",
	"admin.team.siteNameTitle": "Site Name:",
	"admin.team.teamCreationDescription": "When false, the ability to create teams is disabled. The create team button displays error when pressed.",
	"admin.team.teamCreationTitle": "Enable Team Creation: ",
	"admin.team.title": "Team Settings",
	"admin.team.true": "true",
	"admin.team.upload": "Upload",
	"admin.team.uploadDesc": "Customize your user experience by adding a custom image to your login screen. See examples at <a href='http://docs.mattermost.com/administration/config-settings.html#custom-branding' target='_blank'>docs.mattermost.com/administration/config-settings.html#custom-branding</a>.",
	"admin.team.uploaded": "Uploaded!",
	"admin.team.uploading": "Uploading..",
	"admin.team.userCreationDescription": "When false, the ability to create accounts is disabled. The create account button displays error when pressed.",
	"admin.team.userCreationTitle": "Enable User Creation: ",
	"admin.team_analytics.activeUsers": "Active Users With Posts",
	"admin.team_analytics.totalPosts": "Total Posts",
	"admin.userList.title": "Users for {team}",
	"admin.userList.title2": "Users for {team} ({count})",
	"admin.user_item.authServiceEmail": ", <strong>Sign-in Method:</strong> Email",
	"admin.user_item.authServiceNotEmail": ", <strong>Sign-in Method:</strong> {service}",
	"admin.user_item.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.",
	"admin.user_item.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
	"admin.user_item.confirmDemotion": "Confirm Demotion",
	"admin.user_item.confirmDemotionCmd": "platform -assign_role -team_name=\"yourteam\" -email=\"name@yourcompany.com\" -role=\"system_admin\"",
	"admin.user_item.emailTitle": "<strong>Email:</strong> {email}",
	"admin.user_item.inactive": "Inactive",
	"admin.user_item.makeActive": "Make Active",
	"admin.user_item.makeInactive": "Make Inactive",
	"admin.user_item.makeMember": "Make Member",
	"admin.user_item.makeSysAdmin": "Make System Admin",
	"admin.user_item.makeTeamAdmin": "Make Team Admin",
	"admin.user_item.member": "Member",
	"admin.user_item.mfaNo": ", <strong>MFA</strong>: No",
	"admin.user_item.mfaYes": ", <strong>MFA</strong>: Yes",
	"admin.user_item.resetMfa": "Remove MFA",
	"admin.user_item.resetPwd": "Reset Password",
	"admin.user_item.switchToEmail": "Switch to Email/Password",
	"admin.user_item.sysAdmin": "System Admin",
	"admin.user_item.teamAdmin": "Team Admin",
	"analytics.chart.loading": "Loading...",
	"analytics.chart.meaningful": "Not enough data for a meaningful representation.",
	"analytics.system.activeUsers": "Active Users With Posts",
	"analytics.system.channelTypes": "Channel Types",
	"analytics.system.postTypes": "Posts, Files and Hashtags",
	"analytics.system.privateGroups": "Private Groups",
	"analytics.system.publicChannels": "Public Channels",
	"analytics.system.textPosts": "Posts with Text-only",
	"analytics.system.title": "System Statistics",
	"analytics.system.totalChannels": "Total Channels",
	"analytics.system.totalCommands": "Total Commands",
	"analytics.system.totalFilePosts": "Posts with Files",
	"analytics.system.totalHashtagPosts": "Posts with Hashtags",
	"analytics.system.totalIncomingWebhooks": "Incoming Webhooks",
	"analytics.system.totalOutgoingWebhooks": "Outgoing Webhooks",
	"analytics.system.totalPosts": "Total Posts",
	"analytics.system.totalSessions": "Total Sessions",
	"analytics.system.totalTeams": "Total Teams",
	"analytics.system.totalUsers": "Total Users",
	"analytics.team.activeUsers": "Active Users With Posts",
	"analytics.team.newlyCreated": "Newly Created Users",
	"analytics.team.privateGroups": "Private Groups",
	"analytics.team.publicChannels": "Public Channels",
	"analytics.team.recentActive": "Recent Active Users",
	"analytics.team.recentUsers": "Recent Active Users",
	"analytics.team.title": "Team Statistics for {team}",
	"analytics.team.totalPosts": "Total Posts",
	"analytics.team.totalUsers": "Total Users",
	"audit_table.accountActive": "Account made active",
	"audit_table.accountInactive": "Account made inactive",
	"audit_table.action": "Action",
	"audit_table.attemptedAllowOAuthAccess": "Attempted to allow a new OAuth service access",
	"audit_table.attemptedLicenseAdd": "Attempted to add new license",
	"audit_table.attemptedLogin": "Attempted to login",
	"audit_table.attemptedOAuthToken": "Attempted to get an OAuth access token",
	"audit_table.attemptedPassword": "Attempted to change password",
	"audit_table.attemptedRegisterApp": "Attempted to register a new OAuth Application with ID {id}",
	"audit_table.attemptedReset": "Attempted to reset password",
	"audit_table.attemptedWebhookCreate": "Attempted to create a webhook",
	"audit_table.attemptedWebhookDelete": "Attempted to delete a webhook",
	"audit_table.by": " by {username}",
	"audit_table.byAdmin": " by an admin",
	"audit_table.channelCreated": "Created the {channelName} channel/group",
	"audit_table.channelDeleted": "Deleted the channel/group with the URL {url}",
	"audit_table.establishedDM": "Established a direct message channel with {username}",
	"audit_table.failedExpiredLicenseAdd": "Failed to add a new license as it has either expired or not yet been started",
	"audit_table.failedInvalidLicenseAdd": "Failed to add an invalid license",
	"audit_table.failedLogin": "FAILED login attempt",
	"audit_table.failedOAuthAccess": "Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback",
	"audit_table.failedPassword": "Failed to change password - tried to update user password who was logged in through oauth",
	"audit_table.failedWebhookCreate": "Failed to create a webhook - bad channel permissions",
	"audit_table.failedWebhookDelete": "Failed to delete a webhook - inappropriate conditions",
	"audit_table.headerUpdated": "Updated the {channelName} channel/group header",
	"audit_table.ip": "IP Address",
	"audit_table.licenseRemoved": "Successfully removed a license",
	"audit_table.loginAttempt": " (Login attempt)",
	"audit_table.loginFailure": " (Login failure)",
	"audit_table.logout": "Logged out of your account",
	"audit_table.member": "member",
	"audit_table.nameUpdated": "Updated the {channelName} channel/group name",
	"audit_table.oauthTokenFailed": "Failed to get an OAuth access token - {token}",
	"audit_table.revokedAll": "Revoked all current sessions for the team",
	"audit_table.sentEmail": "Sent an email to {email} to reset your password",
	"audit_table.session": "Session ID",
	"audit_table.sessionRevoked": "The session with id {sessionId} was revoked",
	"audit_table.successfullLicenseAdd": "Successfully added new license",
	"audit_table.successfullLogin": "Successfully logged in",
	"audit_table.successfullOAuthAccess": "Successfully gave a new OAuth service access",
	"audit_table.successfullOAuthToken": "Successfully added a new OAuth service",
	"audit_table.successfullPassword": "Successfully changed password",
	"audit_table.successfullReset": "Successfully reset password",
	"audit_table.successfullWebhookCreate": "Successfully created a webhook",
	"audit_table.successfullWebhookDelete": "Successfully deleted a webhook",
	"audit_table.timestamp": "Timestamp",
	"audit_table.updateGeneral": "Updated the general settings of your account",
	"audit_table.updateGlobalNotifications": "Updated your global notification settings",
	"audit_table.updatePicture": "Updated your profile picture",
	"audit_table.updatedRol": "Updated user role(s) to ",
	"audit_table.userAdded": "Added {username} to the {channelName} channel/group",
	"audit_table.userId": "User ID",
	"audit_table.userRemoved": "Removed {username} to the {channelName} channel/group",
	"audit_table.verified": "Sucessfully verified your email address",
	"authorize.access": "Allow <strong>{appName}</strong> access?",
	"authorize.allow": "Allow",
	"authorize.app": "The app <strong>{appName}</strong> would like the ability to access and modify your basic information.",
	"authorize.deny": "Deny",
	"authorize.title": "An application would like to connect to your {teamName} account",
	"backstage_navbar.backToMattermost": "Back to {siteName}",
	"backstage_sidebar.integrations": "Integrations",
	"backstage_sidebar.integrations.commands": "Slash Commands",
	"backstage_sidebar.integrations.incoming_webhooks": "Incoming Webhooks",
	"backstage_sidebar.integrations.outgoing_webhooks": "Outgoing Webhooks",
	"center_panel.recent": "Click here to jump to recent messages. ",
	"chanel_header.addMembers": "Add Members",
	"change_url.close": "Close",
	"change_url.endWithLetter": "Must end with a letter or number",
	"change_url.invalidUrl": "Invalid URL",
	"change_url.longer": "Must be longer than two characters",
	"change_url.noUnderscore": "Can not contain two underscores in a row.",
	"change_url.startWithLetter": "Must start with a letter or number",
	"channel_flow.alreadyExist": "A channel with that URL already exists",
	"channel_flow.changeUrlDescription": "Some characters are not allowed in URLs and may be removed.",
	"channel_flow.changeUrlTitle": "Change {term} URL",
	"channel_flow.channel": "Channel",
	"channel_flow.create": "Create {term}",
	"channel_flow.group": "Group",
	"channel_flow.invalidName": "Invalid Channel Name",
	"channel_flow.set_url_title": "Set {term} URL",
	"channel_header.channel": "Channel",
	"channel_header.channelHeader": "Set Channel Header...",
	"channel_header.delete": "Delete {term}...",
	"channel_header.group": "Group",
	"channel_header.leave": "Leave {term}",
	"channel_header.manageMembers": "Manage Members",
	"channel_header.notificationPreferences": "Notification Preferences",
	"channel_header.recentMentions": "Recent Mentions",
	"channel_header.rename": "Rename {term}...",
	"channel_header.setHeader": "Set {term} Header...",
	"channel_header.setPurpose": "Set {term} Purpose...",
	"channel_header.viewInfo": "View Info",
	"channel_info.close": "Close",
	"channel_info.id": "Channel ID:",
	"channel_info.name": "Channel Name:",
	"channel_info.notFound": "No Channel Found",
	"channel_info.purpose": "Channel Purpose:",
	"channel_info.url": "Channel URL:",
	"channel_invite.add": " Add",
	"channel_invite.addNewMembers": "Add New Members to ",
	"channel_invite.close": "Close",
	"channel_loader.connection_error": "There appears to be a problem with your internet connection.",
	"channel_loader.posted": "Posted",
	"channel_loader.socketError": "Please check connection, Mattermost unreachable. If issue persists, ask administrator to check WebSocket port.",
	"channel_loader.someone": "Someone",
	"channel_loader.something": " did something new",
	"channel_loader.unknown_error": "We received an unexpected status code from the server.",
	"channel_loader.uploadedFile": " uploaded a file",
	"channel_loader.uploadedImage": " uploaded an image",
	"channel_loader.wrote": " wrote: ",
	"channel_members_modal.addNew": " Add New Members",
	"channel_members_modal.close": "Close",
	"channel_members_modal.remove": "Remove",
	"channel_memebers_modal.members": " Members",
	"channel_modal.cancel": "Cancel",
	"channel_modal.channel": "Channel",
	"channel_modal.createNew": "Create New ",
	"channel_modal.descriptionHelp": "Describe how this {term} should be used.",
	"channel_modal.displayNameError": "This field is required",
	"channel_modal.edit": "Edit",
	"channel_modal.group": "Group",
	"channel_modal.modalTitle": "New ",
	"channel_modal.name": "Name",
	"channel_modal.nameEx": "E.g.: \"Bugs\", \"Marketing\", \"客户支持\"",
	"channel_modal.optional": "(optional)",
	"channel_modal.privateGroup1": "Create a new private group with restricted membership. ",
	"channel_modal.privateGroup2": "Create a private group",
	"channel_modal.publicChannel1": "Create a public channel",
	"channel_modal.publicChannel2": "Create a new public channel anyone can join. ",
	"channel_modal.purpose": "Purpose",
	"channel_notifications.allActivity": "For all activity",
	"channel_notifications.allUnread": "For all unread messages",
	"channel_notifications.globalDefault": "Global default ({notifyLevel})",
	"channel_notifications.markUnread": "Mark Channel Unread",
	"channel_notifications.never": "Never",
	"channel_notifications.onlyMentions": "Only for mentions",
	"channel_notifications.override": "Selecting an option other than \"Default\" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.",
	"channel_notifications.preferences": "Notification Preferences for ",
	"channel_notifications.sendDesktop": "Send desktop notifications",
	"channel_notifications.unreadInfo": "The channel name is bolded in the sidebar when there are unread messages. Selecting \"Only for mentions\" will bold the channel only when you are mentioned.",
	"channel_select.placeholder": "--- Select a channel ---",
	"choose_auth_page.emailCreate": "Create new team with email address",
	"choose_auth_page.find": "Find my teams",
	"choose_auth_page.gitlabCreate": "Create new team with GitLab Account",
	"choose_auth_page.googleCreate": "Create new team with Google Apps Account",
	"choose_auth_page.ldapCreate": "Create new team with LDAP Account",
	"choose_auth_page.noSignup": "No sign-up methods configured, please contact your system administrator.",
	"claim.account.noEmail": "No email specified",
	"claim.email_to_ldap.enterLdapPwd": "Enter the ID and password for your LDAP account",
	"claim.email_to_ldap.enterPwd": "Enter the password for your {site} email account",
	"claim.email_to_ldap.ldapId": "LDAP ID",
	"claim.email_to_ldap.ldapIdError": "Please enter your LDAP ID.",
	"claim.email_to_ldap.ldapPasswordError": "Please enter your LDAP password.",
	"claim.email_to_ldap.ldapPwd": "LDAP Password",
	"claim.email_to_ldap.pwd": "Password",
	"claim.email_to_ldap.pwdError": "Please enter your password.",
	"claim.email_to_ldap.ssoNote": "You must already have a valid LDAP account",
	"claim.email_to_ldap.ssoType": "Upon claiming your account, you will only be able to login with LDAP",
	"claim.email_to_ldap.switchTo": "Switch account to LDAP",
	"claim.email_to_ldap.title": "Switch Email/Password Account to LDAP",
	"claim.email_to_oauth.enterPwd": "Enter the password for your {site} account",
	"claim.email_to_oauth.pwd": "Password",
	"claim.email_to_oauth.pwdError": "Please enter your password.",
	"claim.email_to_oauth.ssoNote": "You must already have a valid {type} account",
	"claim.email_to_oauth.ssoType": "Upon claiming your account, you will only be able to login with {type} SSO",
	"claim.email_to_oauth.switchTo": "Switch account to {uiType}",
	"claim.email_to_oauth.title": "Switch Email/Password Account to {uiType}",
	"claim.ldap_to_email.confirm": "Confirm Password",
	"claim.ldap_to_email.email": "You will use the email {email} to login",
	"claim.ldap_to_email.enterLdapPwd": "Enter your {ldapPassword} for your {site} email account",
	"claim.ldap_to_email.enterPwd": "Enter a new password for your email account",
	"claim.ldap_to_email.ldapPasswordError": "Please enter your LDAP password.",
	"claim.ldap_to_email.ldapPwd": "LDAP Password",
	"claim.ldap_to_email.pwd": "Password",
	"claim.ldap_to_email.pwdError": "Please enter your password.",
	"claim.ldap_to_email.pwdNotMatch": "Passwords do not match.",
	"claim.ldap_to_email.ssoType": "Upon claiming your account, you will only be able to login with your email and password",
	"claim.ldap_to_email.switchTo": "Switch account to email/password",
	"claim.ldap_to_email.title": "Switch LDAP Account to Email/Password",
	"claim.oauth_to_email.confirm": "Confirm Password",
	"claim.oauth_to_email.description": "Upon changing your account type, you will only be able to login with your email and password.",
	"claim.oauth_to_email.enterNewPwd": "Enter a new password for your {site} account",
	"claim.oauth_to_email.enterPwd": "Please enter a password.",
	"claim.oauth_to_email.newPwd": "New Password",
	"claim.oauth_to_email.pwdNotMatch": "Password do not match.",
	"claim.oauth_to_email.switchTo": "Switch {type} to email and password",
	"claim.oauth_to_email.title": "Switch {type} Account to Email",
	"confirm_modal.cancel": "Cancel",
	"create_comment.addComment": "Add a comment...",
	"create_comment.comment": "Add Comment",
	"create_comment.commentLength": "Comment length must be less than {max} characters.",
	"create_comment.commentTitle": "Comment",
	"create_comment.file": "File uploading",
	"create_comment.files": "Files uploading",
	"create_post.comment": "Comment",
	"create_post.post": "Post",
	"create_post.tutorialTip": "<h4>Sending Messages</h4><p>Type here to write a message and press <strong>Enter</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>",
	"create_post.write": "Write a message...",
	"create_team.agreement": "By proceeding to create your account and use {siteName}, you agree to our <a href='/static/help/terms.html'>Terms of Service</a> and <a href='/static/help/privacy.html'>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.",
	"create_team.display_name.back": "Back to previous step",
	"create_team.display_name.charLength": "Name must be 4 or more characters up to a maximum of 15",
	"create_team.display_name.nameHelp": "Name your team in any language. Your team name shows in menus and headings.",
	"create_team.display_name.next": "Next",
	"create_team.display_name.required": "This field is required",
	"create_team.display_name.teamName": "Team Name",
	"create_team.team_url.back": "Back to previous step",
	"create_team.team_url.charLength": "Name must be 4 or more characters up to a maximum of 15",
	"create_team.team_url.finish": "Finish",
	"create_team.team_url.hint": "<li>Short and memorable is best</li><li>Use lowercase letters, numbers and dashes</li><li>Must start with a letter and can't end in a dash</li>",
	"create_team.team_url.regex": "Use only lower case letters, numbers and dashes. Must start with a letter and can't end in a dash.",
	"create_team.team_url.required": "This field is required",
	"create_team.team_url.taken": "URL is taken or contains a reserved word",
	"create_team.team_url.teamUrl": "Team URL",
	"create_team.team_url.unavailable": "This URL is unavailable. Please try another.",
	"create_team.team_url.webAddress": "Choose the web address of your new team:",
	"delete_channel.cancel": "Cancel",
	"delete_channel.channel": "channel",
	"delete_channel.confirm": "Confirm DELETE Channel",
	"delete_channel.del": "Delete",
	"delete_channel.group": "group",
	"delete_channel.question": "Are you sure you wish to delete the {display_name} {term}?",
	"delete_post.cancel": "Cancel",
	"delete_post.comment": "Comment",
	"delete_post.confirm": "Confirm {term} Delete",
	"delete_post.del": "Delete",
	"delete_post.post": "Post",
	"delete_post.question": "Are you sure you want to delete this {term}?",
	"delete_post.warning": "This post has {count} comment(s) on it.",
	"edit_channel_header_modal.cancel": "Cancel",
	"edit_channel_header_modal.description": "Edit the text appearing next to the channel name in the channel header.",
	"edit_channel_header_modal.error": "This channel header is too long, please enter a shorter one",
	"edit_channel_header_modal.save": "Save",
	"edit_channel_header_modal.title": "Edit Header for {channel}",
	"edit_channel_purpose_modal.body": "Describe how this {type} should be used. This text appears in the channel list in the \"More...\" menu and helps others decide whether to join.",
	"edit_channel_purpose_modal.cancel": "Cancel",
	"edit_channel_purpose_modal.channel": "Channel",
	"edit_channel_purpose_modal.error": "This channel purpose is too long, please enter a shorter one",
	"edit_channel_purpose_modal.group": "Group",
	"edit_channel_purpose_modal.save": "Save",
	"edit_channel_purpose_modal.title1": "Edit Purpose",
	"edit_channel_purpose_modal.title2": "Edit Purpose for ",
	"edit_post.cancel": "Cancel",
	"edit_post.edit": "Edit {title}",
	"edit_post.editPost": "Edit the post...",
	"edit_post.save": "Save",
	"email_signup.address": "Email Address",
	"email_signup.createTeam": "Create Team",
	"email_signup.emailError": "Please enter a valid email address",
	"email_signup.find": "Find my teams",
	"email_verify.almost": "{siteName}: You are almost done",
	"email_verify.failed": " Failed to send verification email.",
	"email_verify.notVerifiedBody": "Please verify your email address. Check your inbox for an email.",
	"email_verify.resend": "Resend Email",
	"email_verify.sent": " Verification email sent.",
	"email_verify.verified": "{siteName} Email Verified",
	"email_verify.verifiedBody": "<p>Your email has been verified! Click <a href={url}>here</a> to log in.</p>",
	"email_verify.verifyFailed": "Failed to verify your email.",
	"error_bar.preview_mode": "Preview Mode: Email notifications have not been configured",
	"file_attachment.download": "Download",
	"file_info_preview.size": "Size ",
	"file_info_preview.type": "File type ",
	"file_upload.fileAbove": "File above {max}MB could not be uploaded: {filename}",
	"file_upload.filesAbove": "Files above {max}MB could not be uploaded: {filenames}",
	"file_upload.limited": "Uploads limited to {count} files maximum. Please use additional posts for more files.",
	"file_upload.pasted": "Image Pasted at ",
	"filtered_user_list.any_team": "All Users",
	"filtered_user_list.count": "{count} {count, plural, =0 {0 members} one {member} other {members}}",
	"filtered_user_list.countTotal": "{count} {count, plural, =0 {0 members} one {member} other {members}} of {total} Total",
	"filtered_user_list.member": "Member",
	"filtered_user_list.search": "Search members",
	"filtered_user_list.show": "Filter:",
	"filtered_user_list.team_only": "Members of this Team",
	"find_team.email": "Email",
	"find_team.findDescription": "An email was sent with links to any teams to which you are a member.",
	"find_team.findTitle": "Find Your Team",
	"find_team.getLinks": "Get an email with links to any teams to which you are a member.",
	"find_team.placeholder": "you@domain.com",
	"find_team.send": "Send",
	"find_team.submitError": "Please enter a valid email address",
	"general_tab.chooseName": "Please choose a new name for your team",
	"general_tab.codeDesc": "Click 'Edit' to regenerate Invite Code.",
	"general_tab.codeLongDesc": "The Invite Code is used as part of the URL in the team invitation link created by **Get Team Invite Link** in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.",
	"general_tab.codeTitle": "Invite Code",
	"general_tab.dirContact": "Contact your system administrator to turn on the team directory on the system home page.",
	"general_tab.dirDisabled": "Team Directory has been disabled.  Please ask a System Admin to enable the Team Directory in the System Console team settings.",
	"general_tab.dirOff": "Team directory is turned off for this system.",
	"general_tab.includeDirDesc": "Including this team will display the team name from the Team Directory section of the Home Page, and provide a link to the sign-in page.",
	"general_tab.includeDirTitle": "Include this team in the Team Directory",
	"general_tab.no": "No",
	"general_tab.openInviteDesc": "When allowed, a link to this team will be including on the landing page allowing anyone with an account to join this team.",
	"general_tab.openInviteTitle": "Allow anyone to join this team",
	"general_tab.regenerate": "Re-Generate",
	"general_tab.required": "This field is required",
	"general_tab.teamName": "Team Name",
	"general_tab.teamNameInfo": "Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.",
	"general_tab.title": "General Settings",
	"general_tab.yes": "Yes",
	"get_link.clipboard": " Link copied to clipboard.",
	"get_link.close": "Close",
	"get_link.copy": "Copy Link",
	"get_post_link_modal.help": "The link below allows authorized users to see your post.",
	"get_post_link_modal.title": "Copy Permalink",
	"get_team_invite_link_modal.help": "Send teammates the link below for them to sign-up to this team site. The Team Invite Link can be shared with multiple teammates as it does not change unless it's regenerated in Team Settings by a Team Admin.",
	"get_team_invite_link_modal.helpDisabled": "User creation has been disabled for your team. Please ask your team administrator for details.",
	"get_team_invite_link_modal.title": "Team Invite Link",
	"installed_commands.add": "Add Slash Command",
	"installed_commands.empty": "No commands found",
	"installed_commands.header": "Slash Commands",
	"installed_incoming_webhooks.add": "Add Incoming Webhook",
	"installed_incoming_webhooks.empty": "No incoming webhooks found",
	"installed_incoming_webhooks.header": "Incoming Webhooks",
	"installed_integrations.creation": "Created by {creator} on {createAt, date, full}",
	"installed_integrations.delete": "Delete",
	"installed_integrations.regenToken": "Regen Token",
	"installed_integrations.search": "Search Integrations",
	"installed_integrations.token": "Token: {token}",
	"installed_integrations.url": "URL: {url}",
	"installed_outgoing_webhooks.add": "Add Outgoing Webhook",
	"installed_outgoing_webhooks.empty": "No outgoing webhooks found",
	"installed_outgoing_webhooks.header": "Outgoing Webhooks",
	"integrations.command.description": "Slash commands send events to external integrations",
	"integrations.command.title": "Slash Command",
	"integrations.header": "Integrations",
	"integrations.incomingWebhook.description": "Incoming webhooks allow external integrations to send messages",
	"integrations.incomingWebhook.title": "Incoming Webhook",
	"integrations.outgoingWebhook.description": "Outgoing webhooks allow external integrations to receive and respond to messages",
	"integrations.outgoingWebhook.title": "Outgoing Webhook",
	"intro_messages.DM": "This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.",
	"intro_messages.anyMember": " Any member can join and read this channel.",
	"intro_messages.beginning": "Beginning of {name}",
	"intro_messages.channel": "channel",
	"intro_messages.creator": "This is the start of the <strong>{name}</strong> {type}, created by <strong>{creator}</strong> on <strong>{date}</strong>",
	"intro_messages.default": "<h4 class='channel-intro__title'>Beginning of {display_name}</h4><p class='channel-intro__content'><strong>Welcome to {display_name}!</strong><br/><br/>This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.</p>",
	"intro_messages.group": "private group",
	"intro_messages.invite": "Invite others to this {type}",
	"intro_messages.inviteOthers": "Invite others to this team",
	"intro_messages.noCreator": "This is the start of the {name} {type}, created on {date}.",
	"intro_messages.offTopic": "<h4 class=\"channel-intro__title\">Beginning of {display_name}</h4><p class=\"channel-intro__content\">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>",
	"intro_messages.onlyInvited": " Only invited members can see this private group.",
	"intro_messages.setHeader": "Set a Header",
	"intro_messages.teammate": "This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.",
	"invite_member.addAnother": "Add another",
	"invite_member.autoJoin": "People invited automatically join the <strong>{channel}</strong> channel.",
	"invite_member.cancel": "Cancel",
	"invite_member.content": "Email is currently disabled for your team, and email invitations cannot be sent. Contact your system administrator to enable email and email invitations.",
	"invite_member.disabled": "User creation has been disabled for your team. Please ask your team administrator for details.",
	"invite_member.emailError": "Please enter a valid email address",
	"invite_member.firstname": "First name",
	"invite_member.inviteLink": "Team Invite Link",
	"invite_member.lastname": "Last name",
	"invite_member.modalButton": "Yes, Discard",
	"invite_member.modalMessage": "You have unsent invitations, are you sure you want to discard them?",
	"invite_member.modalTitle": "Discard Invitations?",
	"invite_member.newMember": "Invite New Member",
	"invite_member.send": "Send Invitation",
	"invite_member.send2": "Send Invitations",
	"invite_member.sending": " Sending",
	"invite_member.teamInviteLink": "You can also invite people using the {link}.",
	"ldap_signup.find": "Find my teams",
	"ldap_signup.ldap": "Create team with LDAP Account",
	"ldap_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
	"ldap_signup.teamName": "Enter name of new team",
	"ldap_signup.team_error": "Please enter a team name",
	"loading_screen.loading": "Loading",
	"login.changed": " Sign-in method changed successfully",
	"login.create": "Create one now",
	"login.createTeam": "Create a new team",
	"login.email": "Email",
	"login.find": "Find your other teams",
	"login.forgot": "I forgot my password",
	"login.gitlab": "GitLab",
	"login.google": "Google Apps",
	"login.invalidPassword": "Your password is incorrect.",
	"login.ldapUsername": "LDAP Username",
	"login.noAccount": "Don't have an account? ",
	"login.on": "on {siteName}",
	"login.or": "or",
	"login.password": "Password",
	"login.passwordChanged": " Password updated successfully",
	"login.session_expired": " Your session has expired. Please login again.",
	"login.signIn": "Sign in",
	"login.signInWith": "Sign in with:",
	"login.userNotFound": "We couldn't find an account matching your login credentials.",
	"login.username": "Username",
	"login.verified": " Email Verified",
	"login_mfa.enterToken": "To complete the sign in process, please enter a token from your smartphone's authenticator",
	"login_mfa.submit": "Submit",
	"login_mfa.token": "MFA Token",
	"login_mfa.tokenReq": "Please enter an MFA token",
	"member_item.makeAdmin": "Make Admin",
	"member_item.member": "Member",
	"member_list.noUsersAdd": "No users to add.",
	"members_popover.msg": "Message",
	"members_popover.title": "Members",
	"more_channels.close": "Close",
	"more_channels.create": "Create New Channel",
	"more_channels.createClick": "Click 'Create New Channel' to make a new one",
	"more_channels.join": "Join",
	"more_channels.noMore": "No more channels to join",
	"more_channels.title": "More Channels",
	"more_direct_channels.close": "Close",
	"more_direct_channels.message": "Message",
	"more_direct_channels.title": "Direct Messages",
	"msg_typing.areTyping": "{users} and {last} are typing...",
	"msg_typing.isTyping": "{user} is typing...",
	"msg_typing.someone": "Someone",
	"navbar.addMembers": "Add Members",
	"navbar.click": "Click here",
	"navbar.delete": "Delete Channel...",
	"navbar.leave": "Leave Channel",
	"navbar.manageMembers": "Manage Members",
	"navbar.noHeader": "No channel header yet.{newline}{link} to add one.",
	"navbar.preferences": "Notification Preferences",
	"navbar.rename": "Rename Channel...",
	"navbar.setHeader": "Set Channel Header...",
	"navbar.setPurpose": "Set Channel Purpose...",
	"navbar.toggle1": "Toggle sidebar",
	"navbar.toggle2": "Toggle sidebar",
	"navbar.viewInfo": "View Info",
	"navbar_dropdown.about": "About Mattermost",
	"navbar_dropdown.accountSettings": "Account Settings",
	"navbar_dropdown.console": "System Console",
	"navbar_dropdown.create": "Create a New Team",
	"navbar_dropdown.help": "Help",
	"navbar_dropdown.integrations": "Integrations",
	"navbar_dropdown.inviteMember": "Invite New Member",
	"navbar_dropdown.logout": "Logout",
	"navbar_dropdown.manageMembers": "Manage Members",
	"navbar_dropdown.report": "Report a Problem",
	"navbar_dropdown.switchTeam": "Switch to {team}",
	"navbar_dropdown.teamLink": "Get Team Invite Link",
	"navbar_dropdown.teamSettings": "Team Settings",
	"password_form.change": "Change my password",
	"password_form.click": "Click <a href={url}>here</a> to log in.",
	"password_form.enter": "Enter a new password for your {siteName} account.",
	"password_form.error": "Please enter at least {chars} characters.",
	"password_form.pwd": "Password",
	"password_form.title": "Password Reset",
	"password_form.update": "Your password has been updated successfully.",
	"password_send.checkInbox": "Please check your inbox.",
	"password_send.description": "To reset your password, enter the email address you used to sign up",
	"password_send.email": "Email",
	"password_send.error": "Please enter a valid email address.",
	"password_send.link": "<p>A password reset link has been sent to <b>{email}</b></p>",
	"password_send.reset": "Reset my password",
	"password_send.title": "Password Reset",
	"permalink.error.access": "Permalink belongs to a channel you do not have access to",
	"post_attachment.collapse": "▲ collapse text",
	"post_attachment.more": "▼ read more",
	"post_body.commentedOn": "Commented on {name}{apostrophe} message: ",
	"post_body.deleted": "(message deleted)",
	"post_body.plusMore": " plus {count} other files",
	"post_body.plusOne": " plus 1 other file",
	"post_body.retry": "Retry",
	"post_delete.notPosted": "Comment could not be posted",
	"post_delete.okay": "Okay",
	"post_delete.someone": "Someone deleted the message on which you tried to post a comment.",
	"post_focus_view.beginning": "Beginning of Channel Archives",
	"post_info.del": "Delete",
	"post_info.edit": "Edit",
	"post_info.permalink": "Permalink",
	"post_info.reply": "Reply",
	"posts_view.loadMore": "Load more messages",
	"posts_view.newMsg": "New Messages",
	"register_app.callback": "Callback URL",
	"register_app.callbackError": "At least one callback URL must be filled in.",
	"register_app.cancel": "Cancel",
	"register_app.clientId": "Client ID",
	"register_app.clientSecret": "Client Secret",
	"register_app.close": "Close",
	"register_app.credentialsDescription": "Save these somewhere SAFE and SECURE. Treat your Client ID as your app's username and your Client Secret as the app's password.",
	"register_app.credentialsSave": "I have saved both my Client Id and Client Secret somewhere safe",
	"register_app.credentialsTitle": "Your Application Credentials",
	"register_app.description": "Description",
	"register_app.dev": "Developer Applications",
	"register_app.homepage": "Homepage URL",
	"register_app.homepageError": "Homepage must be filled in.",
	"register_app.name": "Application Name",
	"register_app.nameError": "Application name must be filled in.",
	"register_app.optional": "Optional",
	"register_app.register": "Register",
	"register_app.required": "Required",
	"register_app.title": "Register a New Application",
	"removed_channel.channelName": "the channel",
	"removed_channel.from": "Removed from ",
	"removed_channel.okay": "Okay",
	"removed_channel.remover": "{remover} removed you from {channel}",
	"removed_channel.someone": "Someone",
	"rename_channel.cancel": "Cancel",
	"rename_channel.defaultError": " - Cannot be changed for the default channel",
	"rename_channel.displayName": "Display Name",
	"rename_channel.displayNameHolder": "Enter display name",
	"rename_channel.handle": "Handle",
	"rename_channel.handleHolder": "lowercase alphanumeric&#39;s only",
	"rename_channel.lowercase": "Must be lowercase alphanumeric characters",
	"rename_channel.maxLength": "This field must be less than 22 characters",
	"rename_channel.required": "This field is required",
	"rename_channel.save": "Save",
	"rename_channel.title": "Rename Channel",
	"rhs_comment.comment": "Comment",
	"rhs_comment.del": "Delete",
	"rhs_comment.edit": "Edit",
	"rhs_comment.permalink": "Permalink",
	"rhs_comment.retry": "Retry",
	"rhs_header.details": "Message Details",
	"rhs_root.del": "Delete",
	"rhs_root.direct": "Direct Message",
	"rhs_root.edit": "Edit",
	"rhs_root.permalink": "Permalink",
	"search_bar.cancel": "Cancel",
	"search_bar.search": "Search",
	"search_bar.usage": "<h4>Search Options</h4><ul><li><span>Use </span><b>\"quotation marks\"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users and </span><b>in:</b><span> to find posts in specific channels</span></li></ul>",
	"search_header.results": "Search Results",
	"search_header.title2": "Recent Mentions",
	"search_item.direct": "Direct Message",
	"search_item.jump": "Jump",
	"search_results.because": "<ul><li>If you're searching a partial phrase (ex. searching \"rea\", looking for \"reach\" or \"reaction\"), append a * to your search term</li><li>Due to the volume of results, two letter searches and common words like \"this\", \"a\" and \"is\" won't appear in search results</li></ul>",
	"search_results.noResults": "NO RESULTS",
	"search_results.usage": "<ul><li>Use <b>\"quotation marks\"</b> to search for phrases</li><li>Use <b>from:</b> to find posts from specific users and <b>in:</b> to find posts in specific channels</li></ul>",
	"setting_item_max.cancel": "Cancel",
	"setting_item_max.save": "Save",
	"setting_item_min.edit": "Edit",
	"setting_picture.cancel": "Cancel",
	"setting_picture.help": "Upload a profile picture in either JPG or PNG format, at least {width}px in width and {height}px height.",
	"setting_picture.save": "Save",
	"setting_picture.select": "Select",
	"setting_upload.import": "Import",
	"setting_upload.noFile": "No file selected.",
	"setting_upload.select": "Select file",
	"sidebar.channels": "Channels",
	"sidebar.createChannel": "Create new channel",
	"sidebar.createGroup": "Create new group",
	"sidebar.direct": "Direct Messages",
	"sidebar.more": "More",
	"sidebar.moreElips": "More...",
	"sidebar.otherMembers": "Outside this team",
	"sidebar.pg": "Private Groups",
	"sidebar.removeList": "Remove from list",
	"sidebar.tutorialScreen1": "<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They’re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Groups</strong> for multiple people.</p>",
	"sidebar.tutorialScreen2": "<h4>\"{townsquare}\" and \"{offtopic}\" channels</h4><p>Here are two public channels to start:</p><p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p><p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>",
	"sidebar.tutorialScreen3": "<h4>Creating and Joining Channels</h4><p>Click <strong>\"More...\"</strong> to create a new channel or join an existing one.</p><p>You can also create a new channel or private group by clicking the <strong>\"+\" symbol</strong> next to the channel or private group header.</p>",
	"sidebar.unreadAbove": "Unread post(s) above",
	"sidebar.unreadBelow": "Unread post(s) below",
	"sidebar_header.tutorial": "<h4>Main Menu</h4><p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p><p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>",
	"sidebar_right_menu.accountSettings": "Account Settings",
	"sidebar_right_menu.console": "System Console",
	"sidebar_right_menu.help": "Help",
	"sidebar_right_menu.inviteNew": "Invite New Member",
	"sidebar_right_menu.logout": "Logout",
	"sidebar_right_menu.manageMembers": "Manage Members",
	"sidebar_right_menu.report": "Report a Problem",
	"sidebar_right_menu.switch_team": "Switch Team",
	"sidebar_right_menu.teamLink": "Get Team Invite Link",
	"sidebar_right_menu.teamSettings": "Team Settings",
	"signup_team.choose": "Teams you are a member of: ",
	"signup_team.createTeam": "Or Create a Team",
	"signup_team.disabled": "Team creation has been disabled.  Please contact an administrator for access.",
	"signup_team.join_open": "Open teams you can join: ",
	"signup_team.noTeams": "There are no teams included in the Team Directory and team creation has been disabled.",
	"signup_team.no_teams": "You do not appear to be a member of any team.  Please ask your administrator for an invite, join an open team if one exists or possibly create a new team.",
	"signup_team.none": "No team creation method has been enabled.  Please contact an administrator for access.",
	"signup_team_complete.completed": "You've already completed the signup process for this invitation or this invitation has expired.",
	"signup_team_confirm.checkEmail": "Please check your email: <strong>{email}</strong><br />Your email contains a link to set up your team",
	"signup_team_confirm.title": "Sign up Complete",
	"signup_user_completed.choosePwd": "Choose your password",
	"signup_user_completed.chooseUser": "Choose your username",
	"signup_user_completed.create": "Create Account",
	"signup_user_completed.emailHelp": "Valid email required for sign-up",
	"signup_user_completed.emailIs": "Your email address is <strong>{email}</strong>. You'll use this address to sign in to {siteName}.",
	"signup_user_completed.expired": "You've already completed the signup process for this invitation or this invitation has expired.",
	"signup_user_completed.gitlab": "with GitLab",
	"signup_user_completed.google": "with Google",
	"signup_user_completed.invalid_invite": "The invite link was invalid.  Please speak with your Administrator to receive an invitation.",
	"signup_user_completed.lets": "Let's create your account",
	"signup_user_completed.no_open_server": "This server does not allow open signups.  Please speak with your Administrator to receive an invitation.",
	"signup_user_completed.none": "No user creation method has been enabled.  Please contact an administrator for access.",
	"signup_user_completed.onSite": "on {siteName}",
	"signup_user_completed.or": "or",
	"signup_user_completed.passwordLength": "Please enter at least {min} characters",
	"signup_user_completed.required": "This field is required",
	"signup_user_completed.reserved": "This username is reserved, please choose a new one.",
	"signup_user_completed.userHelp": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'",
	"signup_user_completed.usernameLength": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'.",
	"signup_user_completed.validEmail": "Please enter a valid email address",
	"signup_user_completed.welcome": "Welcome to:",
	"signup_user_completed.whatis": "What's your email address?",
	"signup_user_completed.withLdap": "With your LDAP credentials",
	"sso_signup.find": "Find my teams",
	"sso_signup.gitlab": "Create team with GitLab Account",
	"sso_signup.google": "Create team with Google Apps Account",
	"sso_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
	"sso_signup.teamName": "Enter name of new team",
	"sso_signup.team_error": "Please enter a team name",
	"suggestion.mention.all": "Notifies everyone in the team",
	"suggestion.mention.channel": "Notifies everyone in the channel",
	"suggestion.search.private": "Private Groups",
	"suggestion.search.public": "Public Channels",
	"team_export_tab.download": "download",
	"team_export_tab.export": "Export",
	"team_export_tab.exportTeam": "Export your team",
	"team_export_tab.exporting": " Exporting...",
	"team_export_tab.ready": " Ready for ",
	"team_export_tab.unable": " Unable to export: {error}",
	"team_import_tab.failure": " Import failure: ",
	"team_import_tab.import": "Import",
	"team_import_tab.importHelp": "<p>To import a team from Slack go to Slack > Team Settings > Import/Export Data > Export > Start Export. Slack does not allow you to export files, images, private groups or direct messages stored in Slack. Therefore, Slack import to Mattermost only supports importing of text messages in your Slack team's public channels.</p><p>The Slack import to Mattermost is in 'Beta'. Slack bot posts do not yet import and Slack @mentions are not currently supported.</p>",
	"team_import_tab.importSlack": "Import from Slack (Beta)",
	"team_import_tab.importing": " Importing...",
	"team_import_tab.successful": " Import successful: ",
	"team_import_tab.summary": "View Summary",
	"team_member_modal.close": "Close",
	"team_member_modal.members": "{team} Members",
	"team_members_dropdown.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.",
	"team_members_dropdown.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
	"team_members_dropdown.confirmDemotion": "Confirm Demotion",
	"team_members_dropdown.confirmDemotionCmd": "platform -assign_role -team_name=\"yourteam\" -email=\"name@yourcompany.com\" -role=\"system_admin\"",
	"team_members_dropdown.inactive": "Inactive",
	"team_members_dropdown.makeActive": "Make Active",
	"team_members_dropdown.makeAdmin": "Make Team Admin",
	"team_members_dropdown.makeInactive": "Make Inactive",
	"team_members_dropdown.makeMember": "Make Member",
	"team_members_dropdown.member": "Member",
	"team_members_dropdown.systemAdmin": "System Admin",
	"team_members_dropdown.teamAdmin": "Team Admin",
	"team_settings_modal.exportTab": "Export",
	"team_settings_modal.generalTab": "General",
	"team_settings_modal.importTab": "Import",
	"team_settings_modal.title": "Team Settings",
	"textbox.bold": "**bold**",
	"textbox.edit": "Edit message",
	"textbox.help": "Help",
	"textbox.inlinecode": "`inline code`",
	"textbox.italic": "_italic_",
	"textbox.preformatted": "```preformatted```",
	"textbox.preview": "Preview",
	"textbox.quote": ">quote",
	"textbox.strike": "strike",
	"tutorial_intro.allSet": "You’re all set",
	"tutorial_intro.end": "Click “Next” to enter {channel}. This is the first channel teammates see when they sign up. Use it for posting updates everyone needs to know.",
	"tutorial_intro.invite": "Invite teammates",
	"tutorial_intro.next": "Next",
	"tutorial_intro.screenOne": "<h3>Welcome to:</h3><h1>Mattermost</h1><p>Your team communication all in one place, instantly searchable and available anywhere</p><p>Keep your team connected to help them achieve what matters most.</p>",
	"tutorial_intro.screenTwo": "<h3>How Mattermost works:</h3><p>Communication happens in public discussion channels, private groups and direct messages.</p><p>Everything is archived and searchable from any web-enabled desktop, laptop or phone.</p>",
	"tutorial_intro.skip": "Skip tutorial",
	"tutorial_intro.support": "Need anything, just email us at ",
	"tutorial_intro.teamInvite": "Invite teammates",
	"tutorial_intro.whenReady": " when you’re ready.",
	"tutorial_tip.next": "Next",
	"tutorial_tip.ok": "Okay",
	"tutorial_tip.out": "Opt out of these tips.",
	"tutorial_tip.seen": "Seen this before? ",
	"upload_overlay.info": "Drop a file to upload it.",
	"user.settings.advance.embed_preview": "Show preview snippet of links below message",
	"user.settings.advance.embed_toggle": "Show toggle for all embed previews",
	"user.settings.advance.enabled": "enabled",
	"user.settings.advance.feature": " Feature ",
	"user.settings.advance.features": " Features ",
	"user.settings.advance.markdown_preview": "Show markdown preview option in message input box",
	"user.settings.advance.off": "Off",
	"user.settings.advance.on": "On",
	"user.settings.advance.preReleaseDesc": "Check any pre-released features you'd like to preview.  You may also need to refresh the page before the setting will take effect.",
	"user.settings.advance.preReleaseTitle": "Preview pre-release features",
	"user.settings.advance.sendDesc": "If enabled 'Enter' inserts a new line and 'Ctrl + Enter' submits the message.",
	"user.settings.advance.sendTitle": "Send messages on Ctrl + Enter",
	"user.settings.advance.slashCmd_autocmp": "Enable external application to offer slash command autocomplete",
	"user.settings.advance.title": "Advanced Settings",
	"user.settings.custom_theme.awayIndicator": "Away Indicator",
	"user.settings.custom_theme.buttonBg": "Button BG",
	"user.settings.custom_theme.buttonColor": "Button Text",
	"user.settings.custom_theme.centerChannelBg": "Center Channel BG",
	"user.settings.custom_theme.centerChannelColor": "Center Channel Text",
	"user.settings.custom_theme.codeTheme": "Code Theme",
	"user.settings.custom_theme.copyPaste": "Copy and paste to share theme colors:",
	"user.settings.custom_theme.linkColor": "Link Color",
	"user.settings.custom_theme.mentionBj": "Mention Jewel BG",
	"user.settings.custom_theme.mentionColor": "Mention Jewel Text",
	"user.settings.custom_theme.mentionHighlightBg": "Mention Highlight BG",
	"user.settings.custom_theme.mentionHighlightLink": "Mention Highlight Link",
	"user.settings.custom_theme.newMessageSeparator": "New Message Separator",
	"user.settings.custom_theme.onlineIndicator": "Online Indicator",
	"user.settings.custom_theme.sidebarBg": "Sidebar BG",
	"user.settings.custom_theme.sidebarHeaderBg": "Sidebar Header BG",
	"user.settings.custom_theme.sidebarHeaderTextColor": "Sidebar Header Text",
	"user.settings.custom_theme.sidebarText": "Sidebar Text",
	"user.settings.custom_theme.sidebarTextActiveBorder": "Sidebar Text Active Border",
	"user.settings.custom_theme.sidebarTextActiveColor": "Sidebar Text Active Color",
	"user.settings.custom_theme.sidebarTextHoverBg": "Sidebar Text Hover BG",
	"user.settings.custom_theme.sidebarUnreadText": "Sidebar Unread Text",
	"user.settings.developer.applicationsPreview": "Applications (Preview)",
	"user.settings.developer.register": "Register New Application",
	"user.settings.developer.thirdParty": "Open to register a new third-party application",
	"user.settings.developer.title": "Developer Settings",
	"user.settings.display.channelDisplayTitle": "Channel Display Mode",
	"user.settings.display.channeldisplaymode": "Select how text in a channel is displayed.",
	"user.settings.display.clockDisplay": "Clock Display",
	"user.settings.display.fixedWidthCentered": "Fixed width, centered",
	"user.settings.display.fontDesc": "Select the font displayed in the Mattermost user interface.",
	"user.settings.display.fontTitle": "Display Font",
	"user.settings.display.fullScreen": "Full width",
	"user.settings.display.language": "Language",
	"user.settings.display.militaryClock": "24-hour clock (example: 16:00)",
	"user.settings.display.nameOptsDesc": "Set how to display other user's names in posts and the Direct Messages list.",
	"user.settings.display.normalClock": "12-hour clock (example: 4:00 PM)",
	"user.settings.display.preferTime": "Select how you prefer time displayed.",
	"user.settings.display.showFullname": "Show first and last name",
	"user.settings.display.showNickname": "Show nickname if one exists, otherwise show first and last name",
	"user.settings.display.showUsername": "Show username (default)",
	"user.settings.display.teammateDisplay": "Teammate Name Display",
	"user.settings.display.theme.customTheme": "Custom Theme",
	"user.settings.display.theme.describe": "Open to manage your theme",
	"user.settings.display.theme.import": "Import theme colors from Slack",
	"user.settings.display.theme.otherThemes": "See other themes",
	"user.settings.display.theme.themeColors": "Theme Colors",
	"user.settings.display.theme.title": "Theme",
	"user.settings.display.title": "Display Settings",
	"user.settings.general.checkEmail": "Check your email at {email} to verify the address.",
	"user.settings.general.checkEmailNoAddress": "Check your email to verify your new address",
	"user.settings.general.close": "Close",
	"user.settings.general.confirmEmail": "Confirm Email",
	"user.settings.general.email": "Email",
	"user.settings.general.emailGitlabCantUpdate": "Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailHelp1": "Email is used for sign-in, notifications, and password reset. Email requires verification if changed.",
	"user.settings.general.emailHelp2": "Email has been disabled by your system administrator. No notification emails will be sent until it is enabled.",
	"user.settings.general.emailHelp3": "Email is used for sign-in, notifications, and password reset.",
	"user.settings.general.emailHelp4": "A verification email was sent to {email}.",
	"user.settings.general.emailLdapCantUpdate": "Login occurs through LDAP. Email cannot be updated. Email address used for notifications is {email}.",
	"user.settings.general.emailMatch": "The new emails you entered do not match.",
	"user.settings.general.emptyName": "Click 'Edit' to add your full name",
	"user.settings.general.emptyNickname": "Click 'Edit' to add a nickname",
	"user.settings.general.firstName": "First Name",
	"user.settings.general.fullName": "Full Name",
	"user.settings.general.imageTooLarge": "Unable to upload profile image. File is too large.",
	"user.settings.general.imageUpdated": "Image last updated {date}",
	"user.settings.general.lastName": "Last Name",
	"user.settings.general.loginGitlab": "Login done through GitLab ({email})",
	"user.settings.general.loginLdap": "Login done through LDAP ({email})",
	"user.settings.general.newAddress": "New Address: {email}<br />Check your email to verify the above address.",
	"user.settings.general.nickname": "Nickname",
	"user.settings.general.nicknameExtra": "Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.",
	"user.settings.general.notificationsExtra": "By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.",
	"user.settings.general.notificationsLink": "Notifications",
	"user.settings.general.primaryEmail": "Primary Email",
	"user.settings.general.profilePicture": "Profile Picture",
	"user.settings.general.title": "General Settings",
	"user.settings.general.uploadImage": "Click 'Edit' to upload an image.",
	"user.settings.general.username": "Username",
	"user.settings.general.usernameInfo": "Pick something easy for teammates to recognize and recall.",
	"user.settings.general.usernameReserved": "This username is reserved, please choose a new one.",
	"user.settings.general.usernameRestrictions": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'.",
	"user.settings.general.validEmail": "Please enter a valid email address",
	"user.settings.general.validImage": "Only JPG or PNG images may be used for profile pictures",
	"user.settings.import_theme.cancel": "Cancel",
	"user.settings.import_theme.importBody": "To import a theme, go to a Slack team and look for “Preferences -> Sidebar Theme”. Open the custom theme option, copy the theme color values and paste them here:",
	"user.settings.import_theme.importHeader": "Import Slack Theme",
	"user.settings.import_theme.submit": "Submit",
	"user.settings.import_theme.submitError": "Invalid format, please try copying and pasting in again.",
	"user.settings.languages.change": "Change interface language",
	"user.settings.mfa.add": "Add MFA to your account",
	"user.settings.mfa.addHelp": "You can require a smartphone-based token, in addition to your password, to sign into Mattermost.<br/><br/>To enable, download Google Authenticator from <a target='_blank' href='https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8'>iTunes</a> or <a target='_blank' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en'>Google Play</a> for your phone, then<br/><br/>1. Click the <strong>Add MFA to your account</strong> button above.<br/>2. Use Google Authenticator to scan the QR code that appears.<br/>3. Type in the Token generated by Google Authenticator and click <strong>Save</strong>.<br/><br/>When logging in, you will be asked to enter a token from Google Authenticator in addition to your regular credentials.",
	"user.settings.mfa.addHelpQr": "Please scan the bar code with the Google Authenticator app on your smartphone and fill in the token with one provided by the app.",
	"user.settings.mfa.enterToken": "Token (numbers only)",
	"user.settings.mfa.qrCode": "Bar Code",
	"user.settings.mfa.remove": "Remove MFA from your account",
	"user.settings.mfa.removeHelp": "Removing multi-factor authentication means you will no longer require a phone-based passcode to sign-in to your account.",
	"user.settings.modal.advanced": "Advanced",
	"user.settings.modal.confirmBtns": "Yes, Discard",
	"user.settings.modal.confirmMsg": "You have unsaved changes, are you sure you want to discard them?",
	"user.settings.modal.confirmTitle": "Discard Changes?",
	"user.settings.modal.developer": "Developer",
	"user.settings.modal.display": "Display",
	"user.settings.modal.general": "General",
	"user.settings.modal.notifications": "Notifications",
	"user.settings.modal.security": "Security",
	"user.settings.modal.title": "Account Settings",
	"user.settings.notification.allActivity": "For all activity",
	"user.settings.notification.soundConfig": "Please configure notification sounds in your browser settings",
	"user.settings.notifications.channelWide": "Channel-wide mentions \"@channel\"",
	"user.settings.notifications.close": "Close",
	"user.settings.notifications.desktop": "Send desktop notifications",
	"user.settings.notifications.desktopSounds": "Desktop notification sounds",
	"user.settings.notifications.emailInfo": "Email notifications are sent for mentions and direct messages after you’ve been offline for more than 60 seconds or away from {siteName} for more than 5 minutes.",
	"user.settings.notifications.emailNotifications": "Email notifications",
	"user.settings.notifications.header": "Notifications",
	"user.settings.notifications.info": "Desktop notifications are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.",
	"user.settings.notifications.never": "Never",
	"user.settings.notifications.noWords": "No words configured",
	"user.settings.notifications.off": "Off",
	"user.settings.notifications.on": "On",
	"user.settings.notifications.onlyMentions": "Only for mentions and direct messages",
	"user.settings.notifications.sensitiveName": "Your case sensitive first name \"{first_name}\"",
	"user.settings.notifications.sensitiveUsername": "Your non-case sensitive username \"{username}\"",
	"user.settings.notifications.sensitiveWords": "Other non-case sensitive words, separated by commas:",
	"user.settings.notifications.sounds_info": "Desktop notifications sounds are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.",
	"user.settings.notifications.teamWide": "Team-wide mentions \"@all\"",
	"user.settings.notifications.title": "Notification Settings",
	"user.settings.notifications.usernameMention": "Your username mentioned \"@{username}\"",
	"user.settings.notifications.wordsTrigger": "Words that trigger mentions",
	"user.settings.security.close": "Close",
	"user.settings.security.currentPassword": "Current Password",
	"user.settings.security.currentPasswordError": "Please enter your current password",
	"user.settings.security.emailPwd": "Email and Password",
	"user.settings.security.gitlab": "GitLab SSO",
	"user.settings.security.lastUpdated": "Last updated {date} at {time}",
	"user.settings.security.ldap": "LDAP",
	"user.settings.security.loginGitlab": "Login done through Gitlab",
	"user.settings.security.loginLdap": "Login done through LDAP",
	"user.settings.security.logoutActiveSessions": "View and Logout of Active Sessions",
	"user.settings.security.method": "Sign-in Method",
	"user.settings.security.newPassword": "New Password",
	"user.settings.security.oneSignin": "You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.",
	"user.settings.security.password": "Password",
	"user.settings.security.passwordGitlabCantUpdate": "Login occurs through GitLab. Password cannot be updated.",
	"user.settings.security.passwordLdapCantUpdate": "Login occurs through LDAP. Password cannot be updated.",
	"user.settings.security.passwordLengthError": "New passwords must be at least {chars} characters",
	"user.settings.security.passwordMatchError": "The new passwords you entered do not match",
	"user.settings.security.retypePassword": "Retype New Password",
	"user.settings.security.switchEmail": "Switch to using email and password",
	"user.settings.security.switchGitlab": "Switch to using GitLab SSO",
	"user.settings.security.switchGoogle": "Switch to using Google SSO",
	"user.settings.security.switchLdap": "Switch to using LDAP",
	"user.settings.security.title": "Security Settings",
	"user.settings.security.viewHistory": "View Access History",
	"user_list.notFound": "No users found",
	"user_profile.notShared": "Email not shared",
	"view_image.loading": "Loading ",
	"view_image_popover.download": "Download",
	"view_image_popover.file": "File {count} of {total}",
	"view_image_popover.publicLink": "Get Public Link",
	"web.footer.about": "About",
	"web.footer.help": "Help",
	"web.footer.privacy": "Privacy",
	"web.footer.terms": "Terms",
	"web.header.back": "Back",
	"web.root.singup_info": "All team communication in one place, searchable and accessible anywhere"
};


/*****************
 ** WEBPACK FOOTER
 ** ./i18n/en.json
 ** module id = 1753
 ** module chunks = 0
 **/